import { styled } from '@mui/material';
import cn from 'classnames';
import Iconify from 'src/components/iconify';

const CustomIcon = styled(Iconify)(({ theme }) => ({
  color: theme.palette.text.primary,
  '&.active': {
    color: theme.palette.primary.main,
  },
}));

export const ShowDocFooterIcon = ({ showFooter }: { showFooter?: boolean }) => {
  return (
    <CustomIcon
      icon={showFooter ? 'tabler:eye' : 'tabler:eye-off'}
      className={cn({ active: showFooter })}
    />
  );
};
